import React, { useState } from "react";
import TextArea from "../../common/inputs/TextArea";
import Button from "../../common/button/Button";
import { Form, Formik } from "formik";
import { postApi, putApi } from "../../../services/api/globalApi";
import {
  errorMessage,
  successMessage,
} from "../../../utils/toastify-message/ToastifyMessage";
import { stepValidte } from "../../common/validations/stepValidte";
import { PiPencilSimpleLineBold } from "react-icons/pi";
import { convertDate, convertOnlyTime } from "../../../utils/convertDate";

function Steps({ data, reGetData }) {
  const [step, setStep] = useState(null);

  const formHandler = async (values, { resetForm }) => {
    try {
      if (step) {
        const path = `admin/loans/${data?._id}/steps/${step?._id}`;
        const body = values;
        await putApi({ path, body });
        successMessage("مرحله با موفقیت ویرایش شد.");
      } else {
        const path = `admin/loans/${data?._id}/steps`;
        const body = values;
        await postApi({ path, body });
        successMessage("مرحله با موفقیت ثبت شد.");
      }
      resetForm();
      setStep(null);
      reGetData();
    } catch (error) {
      console.log(error);
      errorMessage(error?.response?.data?.errors[0]?.message);
    }
  };

  return (
    <div className="w-11/12 mx-auto  border border-gray-200 rounded-lg mt-6 bg-white dark:bg-[#060d26] shadow-sm p-4">
      <h3 class="mb-4 mt-2 text-lg font-medium leading-none text-gray-900 dark:text-white">
        مرحله جدید
      </h3>
      <div className="mb-4">
        <Formik
          enableReinitialize
          initialValues={{
            text: step?.text || "",
          }}
          validationSchema={stepValidte}
          onSubmit={formHandler}
        >
          {() => (
            <Form>
              <div className="flex gap-4 w-full">
                <TextArea
                  containerClass={"w-full"}
                  name="text"
                  placeholder="متن"
                  type="text"
                />
                {step ? (
                  <Button
                    onClick={() => setStep(null)}
                    type="button"
                    className={`mt-2`}
                    text={"بازگشت"}
                    color="danger"
                  />
                ) : null}
                <Button className={`mt-2`} text={"ارسال"} color="primary" />
              </div>
            </Form>
          )}
        </Formik>
      </div>
      <h3 class="mb-4 mt-6 text-lg font-medium leading-none text-gray-900 dark:text-white">
        مراحل طی شده
      </h3>

      {data?.steps?.length ? (
        <div className="flex flex-col gap-4">
          {data?.steps?.map((item) => {
            return (
              <div
                className="flex flex-col gap-2 p-4 text-sm rounded-lg bg-gray-50 dark:bg-gray-800 dark:text-gray-300"
                role="alert"
              >
                <div className="flex items-center justify-between">
                  <span className="text-justify leading-6 text-gray-900">
                    - {item?.text}
                  </span>
                  <PiPencilSimpleLineBold
                    onClick={() => setStep(item)}
                    size={22}
                    className="text-gray-500 transition-all hover:text-gray-700 cursor-pointer"
                  />
                </div>
                <span className="text-xs text-gray-600">
                  در تاریخ {convertDate(item?.updatedAt, false)} در ساعت{" "}
                  {convertOnlyTime(item?.updatedAt)}
                  {" - "}
                  <span>{item?.name || "ادمین"}</span>
                </span>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="flex justify-center items-cneter py-10 rounded-xl shadow">
          <p>هنوز هیچ مرحله ای ثبت نشده است.</p>
        </div>
      )}
    </div>
  );
}

export default Steps;
